import React from "react";
import { makeStyles } from "@mui/styles";
import GenericButton from "../Button";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

// Assets
import indexxLogoDark from "../../../../assets/header-icons/indexx-logo-v3-dark.svg";
import indexxLogoLight from "../../../../assets/header-icons/indexx-logo-v3-light.svg";
import bitcoinYayLogo from "../../../../assets/logo.webp";

import wallstreetLogo from "../../../../assets/updated/homePage/wallstreet_logo.png";
import emmmLogoDark from "../../../../assets/updated/homePage/Emm_dark.png";
import emmmLogoLight from "../../../../assets/updated/homePage/Emm_light.png";
import { Filter } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  dataShow: {
    opacity: "1 !important",
    visibility: "visible !important",
    "& .bnModalWrap": {
      transform: "scale(1) !important",
    },
  },
  bnMask: {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, .7)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
    zIndex: 1300,
    width: "100%",
    height: "100vh",
  },
  bnTrans: {
    opacity: 0,
    transitionDuration: "250ms",
    transitionProperty: "all",
    transitionTimingFunction: "ease-in-out",
    visibility: "hidden",
  },
  bnModal: {
    "& .bnModalWrap": {
      backgroundColor: theme?.palette?.mode === "light" ? "#ffffff" : "#1e2329",
      borderRadius: "24px",
      boxShadow: "0px 10px 30px rgba(0,0,0,0.5)",
      maxWidth: "90vw",
      overflow: "hidden",
      position: "relative",
      transform: "scale(.9)",
      transitionDuration: "250ms",
      transitionProperty: "all",
      transitionTimingFunction: "ease-in-out",
      width: "480px",
      padding: "40px 24px 32px 24px",
      border: theme?.palette?.mode === "light" ? "none" : "1px solid #333",
    },
  },
  closeButton: {
    position: "absolute !important",
    top: "16px",
    right: "16px",
    color: theme?.palette?.text?.secondary,
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    color: theme?.palette?.text?.primary,
  },
  logo: {
    marginBottom: "32px",
    height: "60px",
  },
  title: {
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "1.2",
    marginBottom: "44px",
    fontFamily: "Poppins, sans-serif",
  },
  description: {
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "1.6",
    marginBottom: "24px",
    color: theme?.palette?.text?.secondary,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  ecosystemRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "4px",
  },
  brandIcon: {
    height: "24px",
    verticalAlign: "middle",
  },
  emmmIcon: {
    height: "36px",
    verticalAlign: "middle",
  },
  WallstreetbrandIcon: {
    height: "24px",
    verticalAlign: "middle",
    filter: theme.palette.mode === "light" ? "invert(1)" : "",
  },
  emmmBrand: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  },
  emmmText: {
    fontWeight: 600,
    fontSize: "15px",
    color: theme?.palette?.text?.primary,
    lineHeight: 1.3,
  },
  benefits: {
    marginTop: "8px",
    fontSize: "14px",
  },
  btnContainer: {
    width: "100%",
    marginTop: "16px",
  },
  continueBtn: {
    backgroundColor: "#11BE6A !important",
    color: "#000 !important",
    fontWeight: "600 !important",
    fontSize: "16px !important",
    borderRadius: "12px !important",
    height: "56px !important",
    "&:hover": {
      backgroundColor: "#0da65d !important",
    },
  },
}));

const RegistrationDetailsModal = ({ onClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <div
      className={`${classes.bnTrans} ${classes.dataShow} ${classes.bnMask} ${classes.bnModal}`}
    >
      <div className="bnModalWrap">
        <div className={classes.contentContainer}>
          <img
            src={isDark ? indexxLogoDark : indexxLogoLight}
            alt="indexx.ai"
            className={classes.logo}
          />

          <h2 className={classes.title}>
            One Account, One Sign in,
            <br />
            Full Ecosystem Access.
          </h2>

          <div className={classes.description}>
            <div className={classes.ecosystemRow}>
              Sign in to
              <img
                src={bitcoinYayLogo}
                alt="Bitcoin Yay"
                className={classes.brandIcon}
              />
              Bitcoin Yay ,
              <img
                src={wallstreetLogo}
                alt="WallStreet"
                className={classes.WallstreetbrandIcon}
              />
              WallStreet and
              <span>
                <img
                  src={isDark ? emmmLogoDark : emmmLogoLight}
                  alt="Eeny Meeny Miny Moe"
                  className={classes.emmmIcon}
                />{" "}
                Eeny Meeny Miny Moe
              </span>
            </div>
            <div>using the same Indexx login.</div>

            <div className={classes.benefits}>
              <div>One secure account. Cross-platform</div>
              <div>No extra setup require</div>
            </div>
          </div>

          <div className={classes.btnContainer}>
            <GenericButton
              text="Continue"
              onClick={onClose}
              className={classes.continueBtn}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationDetailsModal;
